import { useEffect } from "react";
import Button from "../CommonFields/Button";
import React from "react";
import { useState } from "react";
import { zformatDateSubscription } from "../../Utilities/helper";
import { url } from "../../config/url";

const RenewBox = ({ userSubscriptionDetails, onClickRenewSubscription }) => {
  const [userSubscriptionDetails2, setuserSubscriptionDetails] = useState(
    userSubscriptionDetails
  );

  // Fetch RenewBox
  useEffect(() => {
    console.log("userSubscriptionDetails", userSubscriptionDetails);
    setuserSubscriptionDetails(userSubscriptionDetails);
  }, []);
  return (
    <>
      {userSubscriptionDetails2.subscription?.isPremium && (
        <section className="renew-box mt-4 d-flex">
          <div className="first">
            <div>
              {userSubscriptionDetails2?.userLevelIcon?.featuredImage
                ?.default ? (
                <img
                  src={
                    url?.IMAGE_URL +
                    userSubscriptionDetails2?.userLevelIcon?.featuredImage
                      ?.default
                  }
                  alt="user icon"
                  style={{objectFit:"contain"}}
                />
              ) : (
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="35"
                    viewBox="0 0 34 35"
                    fill="none"
                  >
                    <path
                      d="M16.87 2.23193C10.3778 2.23193 6.3791 5.74521 6.36808 5.75116C6.36808 5.75116 6.20207 5.95008 6.17039 6.08292C5.91759 7.15884 5.68201 8.60024 5.68201 9.65237C5.68201 18.5915 13.5388 25.8362 22.8559 25.8362C26.4433 25.8362 30.4351 24.1866 33.107 22.2026C33.167 22.1583 33.3564 21.8603 33.3564 21.8603C33.3681 21.7915 33.7401 20.37 33.7401 18.4177C33.7401 9.47856 26.1871 2.23193 16.8707 2.23193H16.87Z"
                      fill="#B1E4F9"
                    />
                    <path
                      d="M22.854 25.3783C13.5369 25.3783 5.98385 18.1317 5.98385 9.19256C5.98385 8.01089 6.1168 6.85963 6.36753 5.75C2.48805 8.71606 0 13.2881 0 18.4166C0 21.6219 0.971248 24.6104 2.64717 27.1244L31.1585 27.0259C32.1807 25.4676 32.9343 23.7268 33.3565 21.8591C30.4745 24.0612 26.8251 25.3783 22.8546 25.3783H22.854Z"
                      fill="#9DC6FB"
                    />
                    <path
                      d="M16.9168 24.4143L6.45139 26.6276L7.8504 32.0951C8.49101 32.4844 9.16055 32.834 9.85558 33.1393L24.0234 33.0759C24.6916 32.7752 25.337 32.4335 25.9549 32.0542L27.4242 26.6303L16.9174 24.415L16.9168 24.4143Z"
                      fill="#453D81"
                    />
                    <path
                      d="M19.4472 23.0998C19.4472 23.4937 19.1145 23.8129 18.7039 23.8129H15.173C14.7625 23.8129 14.4297 23.4937 14.4297 23.0998C14.4297 22.7059 14.7625 22.3867 15.173 22.3867H18.7039C19.1145 22.3867 19.4472 22.7059 19.4472 23.0998Z"
                      fill="#11113F"
                    />
                    <path
                      d="M19.4472 24.4795C19.4472 24.8733 19.1145 25.1926 18.7039 25.1926H15.173C14.7625 25.1926 14.4297 24.8733 14.4297 24.4795C14.4297 24.0856 14.7625 23.7664 15.173 23.7664H18.7039C19.1145 23.7664 19.4472 24.0856 19.4472 24.4795Z"
                      fill="#11113F"
                    />
                    <path
                      d="M5.71313 26.4722L7.05291 31.5835C7.31328 31.7626 7.57917 31.9344 7.85057 32.0996C9.86264 30.9682 11.2134 28.8718 11.2134 26.4728H5.71382L5.71313 26.4722Z"
                      fill="#11113F"
                    />
                    <path
                      d="M9.2968 25.5715L8.55769 25.9416L8.19812 25.5715H5.71352C4.43987 25.5715 3.3157 26.1868 2.64685 27.1253C3.45071 28.3321 4.41714 29.4291 5.51651 30.3894L5.90157 30.4416L6.14886 30.9155C6.4423 31.1474 6.74331 31.3695 7.0526 31.5823C9.49656 30.5956 11.2124 28.2759 11.2124 25.5722H9.29543L9.2968 25.5715Z"
                      fill="#DA4A54"
                    />
                    <path
                      d="M9.29718 25.5715H8.19919L6.51087 27.4399C6.30973 27.6626 6.20778 27.9587 6.2312 28.2528L6.34968 29.7206C6.35106 29.7345 6.34486 29.7477 6.33384 29.7563L5.51758 30.3894C5.72354 30.5698 5.93501 30.745 6.14992 30.9155L6.85459 30.3768C7.07915 30.2037 7.1997 29.9354 7.17697 29.6598L7.05849 28.1919C7.0516 28.11 7.08122 28.0241 7.1377 27.9626L9.29718 25.5729V25.5715Z"
                      fill="#ECC32E"
                    />
                    <path
                      d="M22.6647 26.4728C22.6647 28.8428 23.9831 30.9173 25.9545 32.058C26.2204 31.8947 26.4815 31.7242 26.7371 31.5471L28.165 26.4722H22.6654L22.6647 26.4728Z"
                      fill="#11113F"
                    />
                    <path
                      d="M28.1651 25.5715H25.6805L25.3209 25.8359L24.5818 25.5715H22.6648C22.6648 28.2428 24.3393 30.5388 26.7371 31.5453C27.0512 31.3279 27.3578 31.0999 27.6553 30.8626L27.8434 30.4264L28.2918 30.3286C29.3912 29.3584 30.3576 28.2488 31.1587 27.0268C30.483 26.1445 29.3939 25.5715 28.1651 25.5715Z"
                      fill="#DA4A54"
                    />
                    <path
                      d="M28.2001 30.2632L27.5451 29.7563C27.534 29.7477 27.5278 29.7345 27.5292 29.7206L27.6477 28.2528C27.6718 27.9587 27.5699 27.6626 27.3687 27.4399L25.6804 25.5715H24.5817L26.7412 27.9613C26.797 28.0234 26.8266 28.1093 26.8197 28.1906L26.7013 29.6585C26.6785 29.934 26.7998 30.2024 27.0236 30.3755L27.6539 30.8619C27.8709 30.6888 28.083 30.511 28.2904 30.3279C28.236 30.2889 28.2022 30.2645 28.1995 30.2625L28.2001 30.2632Z"
                      fill="#ECC32E"
                    />
                    <path
                      d="M25.3202 7.9829C25.3202 6.77612 25.0116 5.63873 24.466 4.63881L15.3831 0.794434C11.5546 1.13215 8.55685 4.22179 8.55685 7.9829V9.95234L8.74835 10.7474L8.55685 11.0785V14.0769C8.55685 15.6247 9.06452 17.0589 9.929 18.2339L10.759 19.1796C12.1209 20.4869 14.0027 21.2958 16.0809 21.2958H17.7954C19.8943 21.2958 21.7927 20.471 23.1573 19.1413L23.9873 18.1797C24.8277 17.0146 25.3195 15.6009 25.3195 14.0769V11.1162L25.0674 10.6159L25.3195 9.99067V7.98356L25.3202 7.9829Z"
                      fill="#634086"
                    />
                    <path
                      d="M21.8461 10.0609C21.8461 7.84424 19.9732 6.04663 17.6621 6.04663H16.2128C13.9025 6.04663 12.0289 7.84358 12.0289 10.0609V18.5955C12.0289 20.8122 13.9018 22.6098 16.2128 22.6098H17.6621C19.9725 22.6098 21.8461 20.8128 21.8461 18.5955V10.0609Z"
                      fill="#453D81"
                    />
                    <path
                      d="M16.9385 13.5573C18.722 13.5573 20.1678 12.1702 20.1678 10.4591C20.1678 8.74797 18.722 7.36084 16.9385 7.36084C15.1551 7.36084 13.7093 8.74797 13.7093 10.4591C13.7093 12.1702 15.1551 13.5573 16.9385 13.5573Z"
                      fill="#11113F"
                    />
                    <path
                      d="M19.1824 10.8069C19.3836 9.61794 18.5421 8.49767 17.3029 8.30468C16.0637 8.11169 14.896 8.91906 14.6949 10.108C14.4937 11.2969 15.3352 12.4172 16.5744 12.6102C17.8136 12.8032 18.9813 11.9958 19.1824 10.8069Z"
                      fill="#DA4A54"
                    />
                    <path
                      d="M17.7797 10.5891C17.8551 10.1434 17.5397 9.72345 17.0752 9.65111C16.6107 9.57877 16.173 9.88141 16.0976 10.3271C16.0222 10.7727 16.3376 11.1927 16.8021 11.265C17.2666 11.3374 17.7043 11.0347 17.7797 10.5891Z"
                      fill="#11113F"
                    />
                    <path
                      d="M16.2878 10.5315C16.6473 10.5315 16.9388 10.2519 16.9388 9.90701C16.9388 9.56209 16.6473 9.28247 16.2878 9.28247C15.9283 9.28247 15.6369 9.56209 15.6369 9.90701C15.6369 10.2519 15.9283 10.5315 16.2878 10.5315Z"
                      fill="white"
                    />
                    <path
                      d="M8.5567 11.08L9.92885 12.3965V18.2361C10.1658 18.5579 10.4289 18.8606 10.7162 19.1408L10.7589 19.1818V12.0667L8.5567 9.95386V11.08Z"
                      fill="#11113F"
                    />
                    <path
                      d="M25.3202 9.99243L23.158 12.067V19.1431L23.2041 19.0975C23.4907 18.8133 23.7524 18.5073 23.9873 18.1815V12.3967L25.3195 11.1186V9.99243H25.3202Z"
                      fill="#11113F"
                    />
                    <path
                      d="M14.8173 20.2962H13.9962V16.6508L13.5216 16.0256V13.916H14.8173V20.2962Z"
                      fill="#DA4A54"
                    />
                    <path
                      d="M19.0601 20.2962H19.8812V16.6508L20.3558 16.0256V13.916H19.0601V20.2962Z"
                      fill="#DA4A54"
                    />
                    <path
                      d="M9.3938 6.88428H10.2238V8.71427H9.3938V6.88428Z"
                      fill="#11113F"
                    />
                    <path
                      d="M10.6606 6.88428H11.4906V8.71427H10.6606V6.88428Z"
                      fill="#11113F"
                    />
                    <path
                      d="M23.6532 6.88428H24.4833V8.71427H23.6532V6.88428Z"
                      fill="#11113F"
                    />
                    <path
                      d="M22.3864 6.88428H23.2165V8.71427H22.3864V6.88428Z"
                      fill="#11113F"
                    />
                    <path
                      d="M20.1744 29.1454H13.7049C11.5792 29.1454 9.85574 30.799 9.85574 32.8385V33.1385C10.1919 33.2866 10.5342 33.424 10.8821 33.5502L22.9965 33.4967C23.3444 33.3665 23.6867 33.2258 24.0229 33.0744V32.8378C24.0229 30.7983 22.2994 29.1448 20.1737 29.1448L20.1744 29.1454Z"
                      fill="#11113F"
                    />
                    <path
                      d="M16.871 34.6001C19.0256 34.6001 21.0935 34.2102 22.9974 33.4977V32.9849C22.9974 31.4873 21.732 30.2739 20.1718 30.2739H13.7092C12.1484 30.2739 10.8837 31.488 10.8837 32.9849V33.5506C12.7442 34.2287 14.7631 34.6001 16.8717 34.6001H16.871Z"
                      fill="white"
                    />
                    <path
                      d="M21.2468 33.3357V33.0053C21.2468 32.2327 20.5938 31.6062 19.7886 31.6062H14.0906C13.2853 31.6062 12.6323 32.2327 12.6323 33.0053V33.3357H21.2461H21.2468Z"
                      fill="#B1E4F9"
                    />
                    <path
                      d="M13.6511 31.3388C13.4892 31.3388 13.3356 31.2469 13.2688 31.0949L10.809 25.4886C10.6251 25.0643 10.7346 24.568 11.0804 24.2527C11.3063 24.0465 11.6025 23.9375 11.9139 23.9474C12.2252 23.956 12.5138 24.0816 12.7267 24.2997L13.368 24.9579C13.5243 25.1185 13.5161 25.3703 13.3487 25.5203C13.1813 25.6703 12.9189 25.6624 12.7625 25.5018L12.1212 24.8436C12.0606 24.7814 11.9786 24.7457 11.8897 24.7431C11.8009 24.7424 11.7168 24.7715 11.6528 24.8303C11.5543 24.9202 11.5233 25.061 11.5749 25.1813L14.0341 30.7856C14.1229 30.9885 14.0237 31.2218 13.813 31.307C13.7606 31.3282 13.7055 31.3381 13.6518 31.3381L13.6511 31.3388Z"
                      fill="#11113F"
                    />
                    <path
                      d="M20.2278 31.3388C20.1741 31.3388 20.1197 31.3288 20.0673 31.3077C19.8559 31.2224 19.7574 30.9891 19.8462 30.7862L22.306 25.1799C22.357 25.0616 22.326 24.9202 22.2275 24.8303C22.1634 24.7715 22.0808 24.7418 21.9905 24.7431C21.9017 24.7457 21.8197 24.7814 21.7591 24.8436L21.1178 25.5018C20.9614 25.6624 20.699 25.671 20.5316 25.5203C20.3642 25.3703 20.3553 25.1185 20.5123 24.9579L21.1536 24.2996C21.3665 24.0816 21.6551 23.956 21.9664 23.9474C22.2764 23.9375 22.574 24.0472 22.7999 24.2527C23.1457 24.568 23.2552 25.0636 23.072 25.4866L20.6115 31.0942C20.5447 31.2462 20.3911 31.3381 20.2285 31.3381L20.2278 31.3388Z"
                      fill="#11113F"
                    />
                    <path
                      d="M17.797 0.763672H16.0825C15.8469 0.763672 15.6141 0.774246 15.384 0.794073C15.3179 2.59895 16.9525 4.46133 19.4006 5.1969C21.3169 5.77319 23.2353 5.50884 24.4669 4.63779C23.2091 2.33526 20.6942 0.763672 17.797 0.763672Z"
                      fill="#8659B9"
                    />
                  </svg>
                </span>
              )}
            </div>
          </div>
          <div className="second pe-1 d-flex flex-column">
            <h6 className="mb-1">
              {userSubscriptionDetails2.gamerjiName
                ? userSubscriptionDetails2.gamerjiName
                : "N/A"}
            </h6>
            <p className="mb-1 d-flex flex-column">
              <p className="mb-1 subcription-detail-label"  style={{color:"white",fontSize:"8px"}}>
                {" "}
              
                {userSubscriptionDetails2.subscription.startDate?.length >
                12 ? (
                  <marquee>
                      premium user since:
                    {" "}
                    
                    {zformatDateSubscription(
                      userSubscriptionDetails2.subscription.startDate
                    )}
                  </marquee>
                ) : (
                  
                  zformatDateSubscription(
                    userSubscriptionDetails2.subscription.startDate
                  )
                )}
                {/* {zformatDateSubscription(
                  userSubscriptionDetails2.subscription.startDate
                )} */}
              </p>
              <p className="mb-0 subcription-detail-label " style={{color:"white",fontSize:"8px"}}>
                {" "}
             
                {userSubscriptionDetails2.subscription.endDate?.length >
                12 ? (
                  <marquee>
                       premium expires on:{" "}
                    {" "}
                    {zformatDateSubscription(
                      userSubscriptionDetails2.subscription.endDate
                    )}
                  </marquee>
                ) : (
                  zformatDateSubscription(
                    userSubscriptionDetails2.subscription.endDate
                  )
                )}
                {/* {zformatDateSubscription(
                  userSubscriptionDetails2.subscription.endDate
                )} */}
              </p>
              

            </p>
          </div>

          <div className="third">
            {userSubscriptionDetails2.isRenewRequired && (
              <button
                className="submit-button renew-btn subscriptio-renew-btn"
                onClick={() => {
                  onClickRenewSubscription(userSubscriptionDetails2?.packId);
                }}
              >
                renew now
              </button>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default RenewBox;
